import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4a456bfa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-comment" }
const _hoisted_2 = { class: "comment-ttile" }
const _hoisted_3 = ["src"]
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "comment-left" }
const _hoisted_6 = { class: "star" }
const _hoisted_7 = { class: "headline" }
const _hoisted_8 = { class: "imgs" }
const _hoisted_9 = ["src", "onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_rate = _resolveComponent("van-rate")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", null, [
        _createElementVNode("img", {
          onError: _cache[0] || (_cache[0] = ($event: any) => ($setup.get_avatar_fn($event))),
          src: $setup.get_user_info.buyerAvatarUrl
        }, null, 40, _hoisted_3),
        _createTextVNode(" " + _toDisplayString($setup.get_user_info.buyerName), 1)
      ]),
      _createElementVNode("span", {
        innerHTML: $setup.get_data_str_fn($props.item.commentCreatedAt) 
      }, null, 8, _hoisted_4)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_van_rate, {
          modelValue: $props.item.commentScore,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($props.item.commentScore) = $event)),
          size: 25,
          color: "#ffd21e",
          "void-icon": "star",
          "void-color": "#eee"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("p", _hoisted_7, _toDisplayString($props.item.commentContents), 1),
      _createElementVNode("div", _hoisted_8, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.item.commentMediaFullList, (i, index) => {
          return (_openBlock(), _createElementBlock("img", {
            src: _ctx.webpFilters($setup.get_img_url(i)),
            alt: "",
            onClick: ($event: any) => ($setup.ImagePreviews($props.item, index)),
            key: i.image_240
          }, null, 8, _hoisted_9))
        }), 128))
      ])
    ])
  ]))
}